import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {PublicNavComponent} from '../shared/public-nav/public-nav.component';

@Component({
  selector: 'app-pr-public-layout',
  standalone: true,
  imports: [RouterOutlet, PublicNavComponent],
  templateUrl: './pr-public-layout.component.html',
  styleUrl: './pr-public-layout.component.scss'
})
export class PrPublicLayoutComponent {}
